<script>
export default {
  name: 'VVoid',
  render(h) {
    return h()
  }
}
</script>
